var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.22 0H3.48C1.56 0 0 1.56 0 3.48V12.1C0 14.93 2.3 17.24 5.14 17.24H16.56C19.39 17.24 21.7 14.94 21.7 12.1V3.48C21.7 1.56 20.14 0 18.22 0ZM17.64 2.3L11.98 8.79C11.69 9.12 11.29 9.3 10.85 9.3C10.41 9.3 10.01 9.12 9.72 8.79L4.05 2.3H17.64ZM16.56 14.93H5.14C3.58 14.93 2.3 13.66 2.3 12.09V3.79L7.98 10.3C8.7 11.13 9.75 11.6 10.84 11.6C11.93 11.6 12.98 11.13 13.7 10.3L19.38 3.79V12.09C19.38 13.65 18.11 14.93 16.54 14.93H16.56Z",
    fill: "#D1A437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.69,
    height: 17.23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.7a54a35a139cfb8c9b2950d3994dca23.svg";
export { ForwardRef as ReactComponent };